import React from "react";

export interface OptionProps {
  onClick: (value: string) => void;
  label: string;
  value: string;
  active?: boolean;
}

export const Option: React.FC<OptionProps> = ({
  label,
  value,
  onClick,
  active,
}) => {
  return (
    <p
      className={`city-option ${active === true ? "city-option-active" : ""}`}
      title={label}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick(value);
      }}
    >
      {label}
    </p>
  );
};

Option.defaultProps = {
  active: false,
};
